module.exports = __webpack_public_path__ + "img/pufa.edeff136.png";